import {setReviewStatus, log} from "../../ApiCalls";
import {LoadingIcon} from "../../Common";

import {ReviewersEnum} from "../../../../Types/ReviewersEnum";

import {azureTokenContext, messageBoxContext, userIdContext} from "../../../../App";

import {Dialog, DialogPanel, DialogTitle, Transition, TransitionChild} from '@headlessui/react'
import React, {Fragment, useContext, useState} from 'react'
import {StatusEnum} from "../../../../Types/StatusEnum";

export default function ContentEditorApproveModal({
                                                      isOpen,
                                                      setIsOpen,
                                                      task,
                                                      setAllTasks,
                                                      setSelectedTasks
                                                  }) {
    let setMessageBoxProp = useContext(messageBoxContext);
    const userId = useContext(userIdContext);
    const azureToken = useContext(azureTokenContext);
    const [isPending, setIsPending] = useState(false);

    const confirmAction = async () => {
        setIsPending(true);
        try {
            const response = await setReviewStatus(ReviewersEnum.ContentReviewer, task.WorkItemId, userId, azureToken);
            if (response.Success === true) {
                updateTasks();
                await log("INFO", `ContentEditor approved document for WorkItemId: ${task.WorkItemId}`, "AuthorsPortal", task.WorkItemId, "ContentEditor", userId, azureToken);
                setMessageBoxPropFunc("SuccessContentReviewerApproval");
            } else {
                await logFailure(response.Message);
                setMessageBoxPropFunc("ErrorContentReviewerApproval");
            }

        } catch (error) {
            console.log("ErrorSetReviewStatus", error);
            await logFailure(error instanceof Error ? error.message : 'Unknown error');
            setMessageBoxPropFunc("ErrorContentReviewerApproval");
        } finally {
            setIsPending(false);
            setIsOpen(false);
        }
    }

    const updateTasks = () => {
        let newTask = {...task};
        newTask.Status = StatusEnum.readyForReview;
        newTask.WorkItemStatus = StatusEnum.readyForReview;
        newTask.DueDate = "";
        newTask.Description = "Vent på innspill fra korrekturleser";
        newTask.GotApprovalFromContentReviewer = true;

        // Update the task in allTasks and selectedTasks
        setAllTasks((prevTasks) =>
            prevTasks.map((t) =>
                t.TaskId === newTask.TaskId ? {...t, ...newTask} : t
            )
        );
        setSelectedTasks((prevTasks) =>
            prevTasks.map((t) =>
                t.TaskId === newTask.TaskId ? {...t, ...newTask} : t
            )
        );


    };

    const logFailure = async (message: string) => {
        await log("ERROR", `ContentEditor approval failed for WorkItemId: ${task.WorkItemId} with message: ${message}`, "AuthorsPortal", task.WorkItemId, "ContentEditor", userId, azureToken);
    };

    const setMessageBoxPropFunc = (prop: string) => {
        // since it is invocated by changes in prop, I want to make sure that it changes
        setMessageBoxProp("");
        setTimeout(() => {
            setMessageBoxProp(prop);
        }, 10);
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25"/>
                </TransitionChild>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel
                                className="w-full max-w-3xl max-h-96 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <DialogTitle
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    Godkjenne Innhold
                                </DialogTitle>
                                <div className="modal-paragraph-container">
                                    <p>
                                        Er du sikker på at du vil godkjenne innholdet i oppgaven "{task.TaskName}"?
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className="confirm-button"
                                        onClick={() => confirmAction()}
                                        disabled={isPending}
                                    >
                                        {isPending && (
                                            <LoadingIcon/>
                                        )}
                                        Godkjent
                                    </button>
                                    <button
                                        type="button"
                                        className="cancel-button"
                                        onClick={() => setIsOpen(false)}
                                        disabled={isPending}
                                    >
                                        {isPending && (
                                            <LoadingIcon/>
                                        )}
                                        Avbryt
                                    </button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

